import { render, staticRenderFns } from "./AddDispatchOrder.vue?vue&type=template&id=814db226&scoped=true"
import script from "./AddDispatchOrder.vue?vue&type=script&lang=js"
export * from "./AddDispatchOrder.vue?vue&type=script&lang=js"
import style0 from "./AddDispatchOrder.vue?vue&type=style&index=0&id=814db226&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "814db226",
  null
  
)

export default component.exports